import { LoadChildrenType } from './shared/lazy-loader/lazy-loader.models';

export const LazyLoadedWidgets = {
    BLAZOR_SHELL: 'blazor-shell',



    MEMBERHEADER_COMMUNITY: 'memberheader-community',
    MEMBERHEADER_MEDICAID: 'memberheader-medicaid',
    MEMBERHEADER_SNAP: 'memberheader-snap',
    MEMBERHEADER_LIS: 'memberheader-lis',
    MEMBERHEADER_VETERAN: 'memberheader-va',
    MEMBERHEADER_SSI: 'memberheader-ssi',

    COMMUNITYLYNK_MENU: 'member-community-menu',

    MEMBERDASHBOARD_COMMUNITY: 'memberdashboard-community',
    MEMBERDASHBOARD_COMMUNITY_PREVIEW: 'memberdashboard-community-preview',
    MEMBERDASHBOARD_MEDICAID: 'memberdashboard-medicaid',
    NEW_MEMBERDASHBOARD_MEDICAID: 'new-memberdashboard-medicaid',
    MEMBERDASHBOARD_SNAP: 'memberdashboard-snap',
    MEMBERDASHBOARD_LIS: 'memberdashboard-lis',
    MEMBERDASHBOARD_VETERAN: 'memberdashboard-va',
    MEMBERDASHBOARD_SSI: 'memberdashboard-ssi',


    COMPONENT_LIS_SUBMISSION_CODE: 'component-lis-submission-code',
    COMPONENT_CONFIRMATION: 'component-confirmation',
    COMPONENT_NOTINTERESTED: 'component-notinterested',
    COMPONENT_NOTQUALIFIED: 'component-notqualified',
    COMPONENT_INTERVIEWDATA: 'component-interviewdata',
    COMPONENT_CASESTAGEROLLBACK: 'component-casestagerollback',
    COMPONENT_SETCASEOWNER: 'component-setcaseowner',
    // COMPONENT_APPLICATIONDOCUMENT: 'component-applicationdocument',
    COMPONENT_MEDICIAD_RECERT_EDUCATION: 'component-medicaid-recert-education',

    COMPONENT_FACILITYREQUESTNOTEDIALOG: 'component-facilityrequestnotedialog',
    COMPONENT_FACILITYREQUESTCOMPLETE: 'component-facilityrequestCOMPLETE',

    DOCUMENT_CUSTOM_COMPOSITE_SELECTION: 'document-custom-composite-selection',

    // Interview Variables
    INTERVIEW_FACILITIES: 'FacilityProvider',
    INTERVIEW_LOCATIONSTATE: 'StateProvider',
    INTERVIEW_BUTTON: 'ButtonProvider',
    INTERVIEW_SEARCH: 'SearchProvider',
    INTERVIEW_SELECTEDMEMBER: 'AssignedMemberProvider',
    INTERVIEW_NOTIFICATION: 'NotificationProvider',
    INTERVIEW_SMSCONSENT: 'SmsConsentProvider',
    //Relationship Dialog
    CONNECTION_DIALOG: 'ConnectionsDialogProvider',
    
    // Main Dashboard
    MAINDASHBOARD_PROCESSQUEUE: 'maindashboard_processqueue',


    // Process Views
    PROCESSQUEUE_GENERIC_LIST: 'processqueue-generic-list',
    PROCESSQUEUE_VIEW_PULL: 'processqueue-view-pull',
    PROCESSQUEUE_PENDINGINTERVIEW_BUTTON: 'processqueue-pendinginterview-button',
    PROCESSVIEW_PENDINGINTERVIEW: 'processview-pendinginterview',
    PROCESSVIEW_TAKENPROCESSES: 'processview-takenprocesses',
    PROCESSVIEW_OPENMEMBER: 'processview-openmember',
    PROCESSVIEW_OPENMEMBER_WORKITEM: 'processview-openmember-workitem',
    PROCESSVIEW_RELEASEMEMBER: 'processview-releasemember',
    PROCESSVIEW_MEMBERHEADER_EXPANSION: 'processview-pendinginterview-expansion',

    PROCESSVIEW_MEMBERREMEDIATION: 'processview_memberremediation',
    PROCESSVIEW_UNIDENTIFIED_DOCUMENTS: 'processview_unidentified_documents',
    PROCESSVIEW_GOVERNMENT_RELATIONS_DOCUMENTS: 'processview_government-relations-documents',
    PROCESSVIEW_CASEANALYST_ROUTER: 'processview_caseanalyst_router',
    PROCESSVIEW_OPEN_GRINTERVIEW: 'processview_open_grinterview',
    // Documents
    DOCUMENT_FORM_5345_FORM: 'document-form-5345-form',

    // Member Components
    COMPONENT_MEMBERCONVERT: 'component-convertmember',
    COMPONENT_MEMBERSUSPEND: 'component-suspendmember',
    COMPONENT_MEMBEROPEN: 'component-memberopen',
    COMPONENT_RESPONSIBLEPARTYOPEN: 'component-responsiblepartyopen',


    // Right Panel
    COMPONENT_RIGHTPANEL_SETTINGS: 'component-rightpanel-settings',
    COMPONENT_RIGHTPANEL_RELATIONS: 'component-rightpanel-dependants',
    COMPONENT_RIGHTPANEL_TELEPHONYCONTEXT: 'component-rightpanel-telephonycontext',
    COMPONENT_RIGHTPANEL_PREVIEWFEATURES: 'component-rightpanel-previewfeatures',


    // Case Timeline
    TIMELINE_ITEM_BASIC_DEPRECATED: 'casetimeline-item',
    TIMELINE_ITEM_BASIC: 'timeline-item',
    TIMELINE_ITEM_MEMBERSESSION: 'casetimeline-item-membersession',
    TIMELINE_ITEM_NOTEMATCHINGMEMBER_DEPRECATED: 'casetimeline-item-notematchingmember',
    TIMELINE_ITEM_NOTEMATCHINGCASE_DEPRECATED: 'casetimeline-item-notematchingcase',
    TIMELINE_ITEM_NOTES: 'timeline-item-notes',
    TIMELINE_ITEM_ACTIVITIES: 'timeline-item-activities',
    TIMELINE_ITEM_OWNERSHIP_DEPRECATED: 'casetimeline-item-ownership',
    TIMELINE_ITEM_OWNERSHIP: 'timeline-item-ownership',
    TIMELINE_ITEM_DOCUMENTMATCHINGCASE_DEPRECATED: 'casetimeline-item-documentmatchingcase',
    TIMELINE_ITEM_DOCUMENTMATCHINGMEMBER_DEPRECATED: 'casetimeline-item-documentmatchingmember',
    TIMELINE_ITEM_DOCUMENTS: 'timeline-item-documents',
    TIMELINE_ITEM_STAGE_DEPRECATED: 'casetimeline-item-stage',
    TIMELINE_ITEM_STAGE: 'timeline-item-stage',
    TIMELINE_ITEM_ROLLBACK_DEPRECATED: 'casetimeline-item-rollback',
    TIMELINE_ITEM_ROLLBACK: 'casetimeline-item-rollback',
    TIMELINE_ITEM_ELIGIBILITY_DEPRECATED: 'casetimeline-item-eligibility',
    TIMELINE_ITEM_ELIGIBILITY: 'timeline-item-eligibility',
    TIMELINE_ITEM_PHONE_DEPRECATED: 'casetimeline-item-phone',
    TIMELINE_ITEM_PHONE: 'timeline-item-phone',
    TIMELINE_ITEM_MAIL_DEPRECATED: 'casetimeline-item-mail',
    TIMELINE_ITEM_MAIL: 'timeline-item-mail',
    //timeline-item-phone
    // WorkItem Timeline
    TIMELINE_QA_REVIEW: 'timeline-workitem-qa-review',
    TIMELINE_QA_REJECT: 'timeline-workitem-qa-reject',
    TIMELINE_QA_ASSIST: 'timeline-workitem-qa-assist',

    // GR Verification workitem
    TIMELINE_GA_VERIFICATION: 'timeline-workitem-gr-verficaion',

    //eLynk Checklist Resend
    TIMELINE_ELYNK_CHECKLIST_RESEND: 'timeline-elynk-checklist-resend',

    // Member Session
    TASK_DIALOG: 'task-dialog',
    MEMBER_TASK_DIALOG: 'member-task-dialog',
    TASK_PRODUCT_SMARTACTION_ADAPTER: 'task-product-smartaction-adapter',
    TASK_INTERVIEW_ADAPTER: 'task-interview-component',
    MEMBER_GUARD_ADAPTER: 'member-guard',


    // Tasks
    MEMBER_TASK_CLOSE_SESSION: 'member-task-close-session',
    TASK_MEMBER_SURVEY: 'task-member-survey',
    TASK_MEMBER_APPLICATION: "member-task-application",


    //Interview Summaries
    INTERVIEW_SUMMARY_DOCUMENT: 'interview-summary-document',
    INTERVIEW_SUMMARY_DEFAULT: 'interview-summary-default',
    INTERVIEW_TASK_SUMMARY_DEFAULT: 'interview-task-summary-default',
    INTERVIEW_SUMMARY_QUALIFICATION: 'interview-summary-qualification',
    INTERVIEW_SUMMARY_MEDICAID_ELIGIBILITY: 'interview-summary-medicaid-eligibility',
    INTERVIEW_SUMMARY_RPC: 'interview-summary-rpc',
    INTERVIEW_SUMMARY_COMMUNITY: 'interview-summary-community',
    INTERVIEW_SUMMARY_APPLICATION_DISASSEMBLY: 'interview-summary-application-disassembly',
    INTERVIEW_SUMMARY_ADDMEMBER: 'interview-summary-addmember',
    INTERVIEW_SUMMARY_COMMUNITY_RECOMMENDATIONS: 'interview-summary-community-recommendations',
    INTERVIEW_SUMMARY_MESSAGES: 'interview-summary-messages',
    INTERVIEW_SUMMARY_MEMBER_ASSESSMENT: 'interview-summary-member-assessment',
    INTERVIEW_SUMMARY_NOTES: 'interview-summary-notes',
    INTERVIEW_SUMMARY_LTSS_ASSESSMENT: 'interview-summary-ltss-assessment',

    //WorkItem
    WORKITEM_OPEN_ITEM_SELECTION: 'workitem-open-item-selection',

    // Smartfields
    ELYNK_SMARTFIELDS_FIELDWRAPPER: 'elynk-smartfields-fieldwrapper',
    SMARTFIELDS_INPUTTEXT: 'smartfields-inputtext',
    SMARTFIELDS_CALENDAR: 'smartfields-calendar',
    SMARTFIELDS_BUTTONGROUP: 'smartfields-buttongroup',
    SMARTFIELDS_BUTTON: 'smartfields-button',
    SMARTFIELDS_CHECKBOX: 'smartfields-checkbox',
    SMARTFIELDS_FLOAT: 'smartfields-float',
    SMARTFIELDS_NUMBER: 'smartfields-number',
    SMARTFIELDS_RADIOBUTTON: 'smartfields-radiobutton',
    SMARTFIELDS_MULTISELECT: 'smartfields-multiselect',
    SMARTFIELDS_DROPDOWN: 'smartfields-dropdown',
    SMARTFIELDS_BOOLEAN: 'smartfields-boolean',
    SMARTFIELDS_TABULAR: 'smartfields-tabular',
    SMARTFIELDS_MESSAGE: 'smartfields-message',

    // SmartIcons
    PHONENUMBER_SMARTICON: 'phone-numbers-smart-icon',
    ADDRESS_SMARTICON: 'addresses-smart-icon',
    PERSON_SMARTICON: 'person-smart-icon',


    //
    PROFILE_DIALOG: 'profile-dialog',

    //
    SMS_CONSENT_DEFAULT: 'sms_consent_default',
    SMS_CONSENT_EPMP: 'sms_consent_epmp',

    //Notification Messages
    MEMBER_NOTIFICATION_MESSAGES: 'member_notification_messags',

    //Views
    PROCESS_VIEW_ITEMS: 'process_views_items',

    //Views
    REPORTS_MENU: 'reports_menu',

    //Work Items
    USER_WORK_ITEMS: 'user_work_items',

    //User Views
    USER_VIEWS: 'user_views',

    //Government Relations
    GR_FOLOWUPS_MENU: 'gr_followups_menu',

    GR_AGENT_FOLOWUPS_ITEMSMENU: 'gr_agent_followups_menu',

    AGENT_FOLLOWUPS: 'gr_agent_followups',

    // Task Orchestrator
    ORCHESTRATOR_FINAL_SUMMARY: 'orchestrator-final-summary'

};


// This will create a dedicated JS bundle for lazy module
export const lazyWidgets: { path: string, loadChildren: LoadChildrenType }[] = [
    // Blazor Shell
    {
        path: LazyLoadedWidgets.BLAZOR_SHELL,
        loadChildren: () => import('./components/blazor-shell/blazor-shell.module').then(m => m.BlazorShellModule)
    },

    // Headers
    {
        path: LazyLoadedWidgets.MEMBERHEADER_COMMUNITY,
        loadChildren: () => import('./pages/member/pages/products/community/header-overview/community-header-overview.module').then(m => m.CommunityHeaderOverviewModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERHEADER_MEDICAID,
        loadChildren: () => import('./pages/member/pages/products/medicaid/header-overview/medicaid-header-overview.module').then(m => m.MedicaidHeaderOverviewModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERHEADER_SNAP,
        loadChildren: () => import('./pages/member/pages/products/snap/header-overview/snap-header-overview.module').then(m => m.SNAPHeaderOverviewModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERHEADER_LIS,
        loadChildren: () => import('./pages/member/pages/products/lis/header-overview/lis-header-overview.module').then(m => m.LISHeaderOverviewModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERHEADER_VETERAN,
        loadChildren: () => import('./pages/member/pages/products/veteran/header-overview/veteran-header-overview.module').then(m => m.VeteranHeaderOverviewModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERHEADER_SSI,
        loadChildren: () => import('./pages/member/pages/products/ssi/header-overview/ssi-header-overview.module').then(m => m.SSIHeaderOverviewModule),
    },

    // Member Dashboard Tiles
    {
        path: LazyLoadedWidgets.COMMUNITYLYNK_MENU,
        loadChildren: () => import('./pages/member/pages/products/community/community-menu/community-menu.module').then(m => m.CommunityMenuModule)
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_COMMUNITY,
        loadChildren: () => import('./pages/member/pages/products/community/dashboard/community-dashboard.module').then(m => m.CommunityDashboardModule)
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_MEDICAID,
        loadChildren: () => import('./pages/member/pages/products/medicaid/dashboard/medicaid-dashboard.module').then(m => m.MedicaidDashboardModule),
    },
    {
        path: LazyLoadedWidgets.NEW_MEMBERDASHBOARD_MEDICAID,
        loadChildren: () => import('./pages/member/pages/products/medicaid/new-dashboard/new-medicaid-dashboard.module').then(m => m.NewMedicaidDashboardModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_SNAP,
        loadChildren: () => import('./pages/member/pages/products/snap/dashboard/snap-dashboard.module').then(m => m.SNAPDashboardModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_LIS,
        loadChildren: () => import('./pages/member/pages/products/lis/dashboard/lis-dashboard.module').then(m => m.LISDashboardModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_SSI,
        loadChildren: () => import('./pages/member/pages/products/ssi/dashboard/ssi-dashboard.module').then(m => m.SSIDashboardModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_LIS_SUBMISSION_CODE,
        loadChildren: () => import('./pages/member/pages/products/lis/components/lis-submission-code/lis-submission-code.module').then(m => m.LISSubmissionCodeModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_MEDICIAD_RECERT_EDUCATION,
        loadChildren: () => import('./pages/member/pages/products/medicaid/components/medicaid-recert-education/medicaid-recert-education.module').then(m => m.RecertEducationComponentModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_VETERAN,
        loadChildren: () => import('./pages/member/pages/products/veteran/dashboard/veteran-dashboard.module').then(m => m.VeteranDashboardModule),
    },
    {
        path: LazyLoadedWidgets.MEMBERDASHBOARD_SSI,
        loadChildren: () => import('./pages/member/pages/products/ssi/dashboard/ssi-dashboard.module').then(m => m.SSIDashboardModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_CONFIRMATION,
        loadChildren: () => import('./pages/member/+components/dashboard/+lazy-components/confirmation/confirmation.module').then(m => m.ConfirmationModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_NOTINTERESTED,
        loadChildren: () => import('./pages/member/+components/dashboard/+lazy-components/notinterested/notinterested.module').then(m => m.NotInterestedModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_CASESTAGEROLLBACK,
        loadChildren: () => import('./pages/member/+components/dashboard/+lazy-components/casestagerollback/casestagerollback.module').then(m => m.CaseStageRollbackModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_SETCASEOWNER,
        loadChildren: () => import('./pages/member/+components/dashboard/+lazy-components/caseowner/caseowner.module').then(m => m.CaseOwnerModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_NOTQUALIFIED,
        loadChildren: () => import('./pages/member/+components/dashboard/+lazy-components/notqualified/notqualified.module').then(m => m.NotQualifiedModule),
    },
    {
        path: LazyLoadedWidgets.DOCUMENT_CUSTOM_COMPOSITE_SELECTION,
        loadChildren: () => import('./components/document-send/document-selection/documentSelection.module').then(m => m.DocumentSelectionModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_BUTTON,
        loadChildren: () => import('./shared/interview-new/+components/button/button.module').then(m => m.ButtonModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SEARCH,
        loadChildren: () => import('./shared/interview-new/+components/search/search.module').then(m => m.SearchModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SELECTEDMEMBER,
        loadChildren: () => import('./shared/interview-new/+components/selected-member-provider/selected-member.module').then(m => m.SelectedMemberModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_NOTIFICATION,
        loadChildren: () => import('./shared/interview-new/+components/notification/notification.module').then(m => m.NotificationModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SMSCONSENT,
        loadChildren: () => import('./shared/interview-new/+components/sms-consent/sms-consent.module').then(m => m.SmsConsentModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_FACILITIES,
        loadChildren: () => import('./shared/interview-new/+components/facilities/facilities.module').then(m => m.FacilitiesModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_LOCATIONSTATE,
        loadChildren: () => import('./shared/interview-new/+components/state/state.module').then(m => m.StateModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_FACILITYREQUESTNOTEDIALOG,
        loadChildren: () => import('./components/facility-request-actions-dialog/facility-request-actions-dialog.module').then(m => m.FacilityRequestActionsDialogModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_FACILITYREQUESTCOMPLETE,
        loadChildren: () => import('./components/facility-request-complete/facility-request-complete.module').then(m => m.FacilityRequestCompleteModule),
    },
    // Main Dashboard Components
    {
        path: LazyLoadedWidgets.MAINDASHBOARD_PROCESSQUEUE,
        loadChildren: () => import('./pages/mywork/process-queue/process-queue.module').then(m => m.ProcessInstanceRequestListModule),
    },

    // Process Views
    {
        path: LazyLoadedWidgets.PROCESSQUEUE_GENERIC_LIST,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/roots/generic-list/generic-list.module').then(m => m.GenericViewModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSQUEUE_VIEW_PULL,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/view-pull/view-pull.module').then(m => m.ViewPullModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSQUEUE_PENDINGINTERVIEW_BUTTON,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/roots/pendinginterview-button/pendinginterview-button.module').then(m => m.TakeInstanceButtonModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_PENDINGINTERVIEW,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/processview_advocatedev/processview_advocatedev.module').then(m => m.ProcessViewAdvocateDevModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_OPENMEMBER,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/processview_openmember/processview_openmember.module').then(m => m.ProcessViewOpenMemberModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_OPENMEMBER_WORKITEM,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/processview_openmember_workitem/processview_openmember_workitem.module').then(m => m.ProcessViewOpenMemberWorkItemModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_OPEN_GRINTERVIEW,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/processview_open_grinterview/processview_open_grinterview.module').then(m => m.ProcessViewOpenGRInterviewModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_RELEASEMEMBER,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/processview_releasemember/processview_releasemember.module').then(m => m.ProcessViewReleaseMemberModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_MEMBERHEADER_EXPANSION,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/roots/generic-list/+lazy-components/member-header-expansion/member-header-expansion.module').then(m => m.MemberHeaderExpansionModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_MEMBERREMEDIATION,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/member-remediation/member-remediation.module').then(m => m.MemberRemediationModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_UNIDENTIFIED_DOCUMENTS,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/unidentified-documents/unidentified-documents.module').then(m => m.UnidentifiedDocumentsModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_GOVERNMENT_RELATIONS_DOCUMENTS,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/government-relations-documents/government-relations-documents.module').then(m => m.GovernmentRelationsDocumentsModule),
    },
    {
        path: LazyLoadedWidgets.PROCESSVIEW_CASEANALYST_ROUTER,
        loadChildren: () => import('./pages/mywork/process-queue/+view-components/views/items/processview_caseanalystrouter/processview_caseanalystrouter.module').then(m => m.ProcessViewCaseAnalystRouterModule),
    },
    // Documents
    {
        path: LazyLoadedWidgets.DOCUMENT_FORM_5345_FORM,
        loadChildren: () => import('./components/document-metadata/form-5345/form-5345.module').then(m => m.Form5345Module),
    },
    // Member Components
    {
        path: LazyLoadedWidgets.COMPONENT_MEMBERCONVERT,
        loadChildren: () => import('./pages/member/+components/member-convert/member-convert.module').then(m => m.MemberConvertModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_MEMBERSUSPEND,
        loadChildren: () => import('./pages/member/+components/member-suspend/member-suspend.module').then(m => m.MemberSuspendModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_MEMBEROPEN,
        loadChildren: () => import('./pages/member/+components/member-open/member-open.module').then(m => m.MemberOpenModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_RESPONSIBLEPARTYOPEN,
        loadChildren: () => import('./pages/member/+components/personrelations-open-dialog/personrelations-open-dialog.module').then(m => m.PersonRelationsOpenDialogModule),
    },

    // Right Panels
    {
        path: LazyLoadedWidgets.COMPONENT_RIGHTPANEL_SETTINGS,
        loadChildren: () => import('./components/rightpanel/rightpanel-user-settings/rightpanel-user-settings.module').then(m => m.UserSettingsRightPanelModule),
    },

    {
        path: LazyLoadedWidgets.COMPONENT_RIGHTPANEL_RELATIONS,
        loadChildren: () => import('./pages/member/+components/rightpanels/rightpanel-member-relations/rightpanel-member-relations.module').then(m => m.RightPanelMemberRelationsModule),
    },
    {
        path: 'component-rightpanel-relations',
        loadChildren: () => import('./pages/member/+components/rightpanels/rightpanel-member-relations/rightpanel-member-relations.module').then(m => m.RightPanelMemberRelationsModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_RIGHTPANEL_TELEPHONYCONTEXT,
        loadChildren: () => import('./pages/member/+components/rightpanels/rightpanel-member-relations/rightpanel-member-relations.module').then(m => m.RightPanelMemberRelationsModule),
    },
    {
        path: LazyLoadedWidgets.COMPONENT_RIGHTPANEL_PREVIEWFEATURES,
        loadChildren: () => import('./shared/preview-feature/preview-feature.module').then(m => m.PreviewFeatureModule),
    },
    // WorkItem Timeline
    {
        path: LazyLoadedWidgets.TIMELINE_QA_REVIEW,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-workitem/workitem-timeline-qa-review/workitem-timeline-qa-review.module').then(m => m.WorkitemTimelineQaReviewModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_QA_REJECT,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-workitem/workitem-timeline-qa-reject/workitem-timeline-qa-reject.module').then(m => m.WorkitemTimelineQaRejectModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_QA_ASSIST,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-workitem/workitem-timeline-qa-assist/workitem-timeline-qa-assist.module').then(m => m.WorkitemTimelineQaAssistModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_GA_VERIFICATION,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-workitem/timeline-item-verification/timeline-item-verification.module').then(m => m.TimelineItemVerificationModule),
    },

    // eLynk Checklist Resend
    {
        path: LazyLoadedWidgets.TIMELINE_ELYNK_CHECKLIST_RESEND,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-elynk-checklist/timeline-item-elynk-resend-checklist.module').then(m => m.TimelineItemElynkResendChecklistModule),
    },

    // Case Timeline
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_BASIC_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item/timeline-item.module').then(m => m.TimelineItemModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_BASIC,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item/timeline-item.module').then(m => m.TimelineItemModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_NOTEMATCHINGCASE_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-note/timeline-item-note.module').then(m => m.TimelineItemNoteModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_NOTEMATCHINGMEMBER_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-note/timeline-item-note.module').then(m => m.TimelineItemNoteModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_NOTES,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-note/timeline-item-note.module').then(m => m.TimelineItemNoteModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_ACTIVITIES,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-activity/timeline-item-activity.module').then(m => m.TimelineItemActivityModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_OWNERSHIP_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-ownership/timeline-item-ownership.module').then(m => m.TimelineItemOwnershipModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_OWNERSHIP,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-ownership/timeline-item-ownership.module').then(m => m.TimelineItemOwnershipModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_ELIGIBILITY_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-eligibility/timeline-item-eligibility.module').then(m => m.TimelineItemEligibilityModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_ELIGIBILITY,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-eligibility/timeline-item-eligibility.module').then(m => m.TimelineItemEligibilityModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_DOCUMENTMATCHINGCASE_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-document/timeline-item-document.module').then(m => m.TimelineItemDocumentModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_DOCUMENTMATCHINGMEMBER_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-document/timeline-item-document.module').then(m => m.TimelineItemDocumentModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_DOCUMENTS,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-document/timeline-item-document.module').then(m => m.TimelineItemDocumentModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_STAGE_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-stage/timeline-item-stage.module').then(m => m.TimelineItemStageModule),
        // loadChildren: () => import('./pages/member/+components/timeline/+items-components/timeline-item-note/timeline-item-note.module').then(m => m.TimelineItemNoteModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_STAGE,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-stage/timeline-item-stage.module').then(m => m.TimelineItemStageModule),
        // loadChildren: () => import('./pages/member/+components/timeline/+items-components/timeline-item-note/timeline-item-note.module').then(m => m.TimelineItemNoteModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_ROLLBACK_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-stage/timeline-item-stage.module').then(m => m.TimelineItemStageModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_ROLLBACK,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-stage/timeline-item-stage.module').then(m => m.TimelineItemStageModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_PHONE_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-phone/timeline-item-phone.module').then(m => m.TimelineItemPhoneModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_PHONE,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-phone/timeline-item-phone.module').then(m => m.TimelineItemPhoneModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_MAIL_DEPRECATED,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-mail/timeline-item-mail.module').then(m => m.TimelineItemMailModule),
    },
    {
        path: LazyLoadedWidgets.TIMELINE_ITEM_MAIL,
        loadChildren: () => import('./pages/member/+components/timeline-components/timeline-item-mail/timeline-item-mail.module').then(m => m.TimelineItemMailModule),
    },

    // MEMBER Notification messages
    {
        path: LazyLoadedWidgets.MEMBER_NOTIFICATION_MESSAGES,
        loadChildren: () => import('./pages/mywork/notification-items/notification-items-menu/notification-items-menu.module').then(m => m.NotificationItemsMenuModule),
    },

    // Views
    {
        path: LazyLoadedWidgets.PROCESS_VIEW_ITEMS,

        loadChildren: () => import('./pages/mywork/process-queue/+view-components/process-view-items/process-view-items-menu/process-view-items-menu.module').then(m => m.ProcessViewItemsMenuModule),
    },

    // Reports
    {
        path: LazyLoadedWidgets.REPORTS_MENU,

        loadChildren: () => import('./shared/reports/powerbi-menu/powerbi-menu.module').then(m => m.PowerBiReportsMenuModule),
    },

    // work items
    {
        path: LazyLoadedWidgets.USER_WORK_ITEMS,

        loadChildren: () => import('./pages/mywork/work-items/work-item-menu/work-item-menu.module').then(m => m.WorkItemMenuModule),
    },

    // user views
    {
        path: LazyLoadedWidgets.USER_VIEWS,

        loadChildren: () => import('./pages/mywork/user-views/user-views-menu/user-views-menu.module').then(m => m.UserViewsMenuModule),
    },

    // GR Office followup interview
    {
        path: LazyLoadedWidgets.GR_FOLOWUPS_MENU,
        loadChildren: () => import('./pages/government-relations/office-followups/office-followups.module').then(m => m.OfficeFollowupsModule),
    },
    {
        path: LazyLoadedWidgets.GR_AGENT_FOLOWUPS_ITEMSMENU,
        loadChildren: () => import('./pages/government-relations/office-followups/agent-office-followups/agent-office-followups.module').then(m => m.AgentOfficeFollowupsModule),
    },
    {
        path: LazyLoadedWidgets.AGENT_FOLLOWUPS,

        loadChildren: () => import('./pages/government-relations/office-followups/agent-office-followups/agent-office-followup-items/agent-office-followup-items.module').then(m => m.AgentOfficeFollowupItemsModule),
    },
    //Task Adapter
    {
        path: LazyLoadedWidgets.MEMBER_TASK_DIALOG,
        loadChildren: () => import('./pages/member/+components/tasks/member-task-dialog/member-task-dialog.module').then(m => m.MemberTaskDialogModule),
    },
    {
        path: LazyLoadedWidgets.TASK_DIALOG,
        loadChildren: () => import('./components/task-dialog/task-dialog.module').then(m => m.TaskDialogModule),
    },
    {
        path: LazyLoadedWidgets.TASK_INTERVIEW_ADAPTER,
        loadChildren: () => import('./shared/interview-new/instances/task-adapter-interview/task-adapter-interview.module').then(m => m.TaskAdapterInterviewModule),
    },
    {
        path: LazyLoadedWidgets.TASK_PRODUCT_SMARTACTION_ADAPTER,
        loadChildren: () => import('./pages/member/+components/tasks/task-adapter-smartaction/task-adapter-smartaction.module').then(m => m.TaskAdapterSmartActionModule),
    },

    {
        path: LazyLoadedWidgets.MEMBER_TASK_CLOSE_SESSION,
        loadChildren: () => import('./pages/member/+components/tasks/confirm-close-membersession-dialog/confirm-close-membersession-dialog.module').then(m => m.ConfirmCloseMemberSessionDialogModule),
    },
    {
        path: LazyLoadedWidgets.TASK_MEMBER_SURVEY,
        loadChildren: () => import('./pages/member/+components/tasks/member-session-survey/member-session-survey.module').then(m => m.MemberSessionSurveyModule),
    },
    {
        path: LazyLoadedWidgets.TASK_MEMBER_APPLICATION,
        loadChildren: () => import('./pages/member/+components/tasks/application-task-adapter/application-task-adapter.module').then(m => m.ApplicationTaskAdapterModule),
    },
    {
        path: LazyLoadedWidgets.MEMBER_GUARD_ADAPTER,
        loadChildren: () => import('./pages/member/+components/tasks/member-task-guard/member-task-guard.module').then(m => m.MemberTaskGuardModule),
    },

    // Interview Summaries
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_DOCUMENT,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-document/interview-summary-document.module').then(m => m.InterviewSummaryDocumentModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_DEFAULT,
        loadChildren: () => import('./shared/interview-new/+components/summary/base-summary.module').then(m => m.DefaultSummaryModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_TASK_SUMMARY_DEFAULT,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-task/interview-summary-task.module').then(m => m.InterviewTaskSummaryDefaultModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_QUALIFICATION,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-qualification/interview-summary-qualification.module').then(m => m.InterviewSummaryQualificationModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_MEDICAID_ELIGIBILITY,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-medicaid-eligibility/interview-summary-medicaid-eligibility.module').then(m => m.InterviewSummaryMedicaidEligibilityModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_RPC,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-rpc/interview-summary-rpc.module').then(m => m.InterviewSummaryRPCModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_COMMUNITY,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-community/interview-summary-community.module').then(m => m.InterviewSummaryCommunityModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_APPLICATION_DISASSEMBLY,
        loadChildren: () => import('./pages/member/+components/tasks/application-task-adapter/application-disassembly-interview-adapter/int-sum-app-dis/int-sum-app-dis.module').then(m => m.InterviewSummaryApplicationDisassemblyModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_ADDMEMBER,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-addmember/interview-summary-addmember.module').then(m => m.InterviewSummaryAddMemberModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_COMMUNITY_RECOMMENDATIONS,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-community-recommendations/interview-summary-community-recommendations.module').then(m => m.InterviewSummaryCommunityRecommendationsModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_MEMBER_ASSESSMENT,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-member-assessment/interview-summary-member-assessment.module').then(m => m.InterviewSummaryMemberAssessmentModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_NOTES,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-notes/interview-summary-notes.module').then(m => m.InterviewSummaryNotesModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_MESSAGES,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-messages/interview-summary-messages.module').then(m => m.InterviewSummaryMessagesModule),
    },
    {
        path: LazyLoadedWidgets.INTERVIEW_SUMMARY_LTSS_ASSESSMENT,
        loadChildren: () => import('./shared/interview-new/+components/summary/interview-summary-ltss-assessment/interview-summary-ltss-assessment.module').then(m => m.InterviewSummaryLtssAssessmentModule),
    },

    // WORKITEM
    {
        path: LazyLoadedWidgets.WORKITEM_OPEN_ITEM_SELECTION,
        loadChildren: () => import('./pages/mywork/work-items-selection/work-items-selection.module').then(m => m.WorkItemsSelectionModule),
    },


    // SMARTFIELDS
    // {
    //     path: LazyLoadedWidgets.ELYNK_SMARTFIELDS_FIELDWRAPPER,
    //     loadChildren: () => import('./pages/member/+components/tasks/application-task-adapter/application-smartfields/application-smartfield-wrapper/application-smartfield-wrapper.module').then(m => m.ApplicationSmartfieldWrapperModule),
    // },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_INPUTTEXT,
        loadChildren: () => import('./shared/smartfields/field-components/inputtext-field-component/inputtext-field-component.module').then(m => m.SmartFieldInputTextModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_CALENDAR,
        loadChildren: () => import('./shared/smartfields/field-components/calendar-field-component/calendar-field-component.module').then(m => m.SmartFieldCalendarModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_BUTTONGROUP,
        loadChildren: () => import('./shared/smartfields/field-components/buttongroup-field-component/buttongroup-field-component.module').then(m => m.SmartFieldButtonGroupModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_BUTTON,
        loadChildren: () => import('./shared/smartfields/field-components/button-smart-field/button-smart-field.module').then(m => m.SmartFieldButtonModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_CHECKBOX,
        loadChildren: () => import('./shared/smartfields/field-components/checkbox-field-component/checkbox-field-component.module').then(m => m.SmartFieldCheckboxModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_RADIOBUTTON,
        loadChildren: () => import('./shared/smartfields/field-components/radiobutton-field-component/radiobutton-field-component.module').then(m => m.SmartFieldRadioButtonModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_MULTISELECT,
        loadChildren: () => import('./shared/smartfields/field-components/multiselect-field-component/multiselect-field.module').then(m => m.SmartFieldMultiSelectModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_DROPDOWN,
        loadChildren: () => import('./shared/smartfields/field-components/dropdown-field-component/dropdown-field.module').then(m => m.SmartFieldDropdownModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_BOOLEAN,
        loadChildren: () => import('./shared/smartfields/field-components/boolean-field-component/boolean-field.module').then(m => m.SmartFieldBooleanModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_NUMBER,
        loadChildren: () => import('./shared/smartfields/field-components/number-field-component/number-field.module').then(m => m.SmartFieldNumberModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_TABULAR,
        loadChildren: () => import('./shared/smartfields/field-components/tabular-field-component/tabular-field.module').then(m => m.SmartFieldTabularModule),
    },
    {
        path: LazyLoadedWidgets.SMARTFIELDS_MESSAGE,
        loadChildren: () => import('./shared/smartfields/field-components/message-field-component/message-field.module').then(m => m.SmartFieldMessageModule),
    },
    {
        path: LazyLoadedWidgets.PROFILE_DIALOG,
        loadChildren: () => import('./components/profile/profile.module').then(m => m.ProfileModule)
    },
    {
        path: LazyLoadedWidgets.SMS_CONSENT_DEFAULT,
        loadChildren: () => import('./pages/member/pages/profile/sms-consent-default/sms-consent.module').then(m => m.SmsConsentDefaultModule),
    },
    {
        path: LazyLoadedWidgets.SMS_CONSENT_EPMP,
        loadChildren: () => import('./pages/member/pages/profile/sms-consent-epmp/sms-consent-epmp.module').then(m => m.SmsConsentEPMPModule),
    },


    // SMART ICONS
    {
        path: LazyLoadedWidgets.PHONENUMBER_SMARTICON,
        loadChildren: () => import('./pages/member/+components/smart-icons/phone-numbers/phone-numbers-smart-icon.module').then(m => m.PhoneNumbersSmartIconModule),
    },
    {
        path: LazyLoadedWidgets.ADDRESS_SMARTICON,
        loadChildren: () => import('./pages/member/+components/smart-icons/addresses/addresses-smart-icon.module').then(m => m.AddressesSmartIconModule),
    },
    {
        path: LazyLoadedWidgets.PERSON_SMARTICON,
        loadChildren: () => import('./pages/member/+components/smart-icons/person/person-smart-icon.module').then(m => m.PersonSmartIconModule),
    },

    // Task Orchestrator
    {
        path: LazyLoadedWidgets.ORCHESTRATOR_FINAL_SUMMARY,
        loadChildren: () => import('./pages/member/+components/task-orchestrator/orchestrator-final-summary/orchestrator-final-summary.module').then(m => m.OrchestratorFinalSummaryModule)
    },

    //Connections Dialogs
    {
      path: LazyLoadedWidgets.CONNECTION_DIALOG,
      loadChildren: () => import('./pages/member/+components/smart-icons/connections/connections-provider/connections-provider.module').then(m => m.ConnectionsProviderModule)
    },
    
];

// This function will work as a factory for injecting lazy widget array in the main module
export function lazyArrayToObj() {
    const result = {};
    for (const w of lazyWidgets) {
        result[w.path] = w.loadChildren;
    }
    return result;
}
